var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgL03 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.00 0.00 366.00 455.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(-959.00, 0.00)",
    id: "L3_Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1137.71,51.50 C1131.35,52.18 1115.93,55.81 1108.45,58.38 C1100.97,60.98 1085.68,67.89 1077.87,72.20 C1071.22,75.89 1034.56,98.93 1022.61,106.91 C1013.30,113.36 1003.83,120.59 995.87,127.86 C989.01,134.15 980.61,144.11 976.94,150.05 C973.64,155.42 967.73,168.27 966.46,173.34 C964.77,180.24 962.82,193.30 962.38,200.69 C962.15,204.89 962.56,212.00 963.29,216.13 C964.79,224.38 971.26,241.31 975.49,248.82 C978.19,253.42 986.87,266.73 991.35,273.06 C996.17,279.57 1006.83,293.11 1012.55,300.02 C1018.14,306.50 1029.18,319.02 1034.54,324.77 C1039.79,330.23 1052.41,342.57 1056.15,345.65 C1063.51,351.69 1077.05,361.02 1083.51,364.50 C1090.03,367.99 1102.79,372.64 1110.25,374.22 C1117.72,375.78 1133.17,377.16 1141.33,377.02 C1147.24,376.87 1162.81,375.50 1170.47,374.54 C1178.38,373.35 1197.20,369.92 1203.20,368.25 C1211.32,365.96 1226.49,359.55 1233.54,355.42 C1240.43,351.35 1252.42,342.04 1258.49,335.65 C1263.78,330.04 1273.47,317.32 1277.87,310.21 C1282.27,303.08 1288.45,290.74 1293.68,278.99 C1300.30,263.46 1313.27,229.75 1315.58,220.76 C1318.19,210.49 1320.95,193.06 1321.11,185.75 C1321.24,178.74 1319.21,165.13 1317.06,158.57 C1316.07,155.58 1313.27,148.88 1311.53,146.07 C1307.78,140.13 1299.33,129.76 1294.01,124.59 C1289.88,120.60 1276.01,109.28 1269.17,104.12 C1261.93,98.92 1250.34,91.05 1241.27,85.75 C1234.90,82.16 1221.75,74.93 1214.97,71.28 C1207.78,67.57 1192.41,59.73 1185.55,57.28 C1177.91,54.57 1162.19,51.48 1154.11,51.09 C1150.06,50.90 1141.35,51.13 1137.71,51.50 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL03, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L-03.fe9baf6e.svg";
export { ForwardRef as ReactComponent };